module.exports = __webpack_public_path__ + "voip-mute.png?460ba6a7dc65c0ce8f49d3fcd06bec22";